import { useT } from "../../i18n";

export const Process = () => {
  const t = useT();
  return (
    <section
      id="process"
      className="sp-section sp-section--alt"
      data-testid="section-process"
    >
      <div className="sp-container">
        <div className="sp-reveal">
          <span className="sp-eyebrow">{t.process.eyebrow}</span>
          <h2 className="sp-title">{t.process.title}</h2>
          <p className="sp-lead">{t.process.lead}</p>
        </div>
        <div className="sp-process-steps sp-reveal">
          {t.process.steps.map((s, i) => (
            <div className="sp-process-step" key={i}>
              <span className="sp-step-num">
                {t.process.stepLabel} {String(i + 1).padStart(2, "0")}
              </span>
              <h4>{s.title}</h4>
              <p>{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
